import responseFields from '../../../../common/constants/responseFields'
import { denormalizeDecimalFields } from '../../../../utils/general'
import { Criteria, filterEmptyDetailSearchValues } from '../utils'

// Transforms flat form values (contactProfileService/Status, price format) to match the API's criteria shape.
// TODO: check with backend whether the criteria contract could accept contactProfileService/Status as flat fields, to avoid this transforming.
export const transformContactDetailSearchCriteria = (values: Criteria = {}): Criteria => {
    const {
        [responseFields.CONTACT_PROFILE_SERVICE]: profileService,
        [responseFields.CONTACT_PROFILE_STATUS]: profileStatus,
        ...restContact
    } = filterEmptyDetailSearchValues(values.contact as Criteria)

    const filteredProfile = filterEmptyDetailSearchValues(values.contactProfile as Criteria)

    return {
        ...restContact,
        contactProfile: {
            ...filteredProfile,
            ...denormalizeDecimalFields(filteredProfile, [responseFields.PRICE_FROM, responseFields.PRICE_TO]),
            ...(profileService ? { [responseFields.CONTACT_PROFILE_SERVICE]: profileService } : {}),
            ...(profileStatus ? { [responseFields.CONTACT_PROFILE_STATUS]: profileStatus } : {}),
        },
    }
}
